import http from "http";
import https from "https";
import axios from "axios";

const httpAgentConfig = {
    keepAlive: true,
    timeout: 5000,
    maxSockets: Infinity
};

export const axiosClient = axios.create({
    timeout: 5000,
    httpAgent: new http.Agent(httpAgentConfig),
    httpsAgent: new https.Agent(httpAgentConfig),
    maxRedirects: 10,
    maxContentLength: 50 * 1000 * 1000
});
